import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {ProDirectorySection} from '../../../../core/content/types/pro-directory-page.types'
import {ProDirectoryModule} from '../../pro-directory/pro-directory.module'
import {ContentSectionComponent} from '../../../../craft/content-section/content-section.component'

@Component({
  selector: 'bgo-pro-directory-section',
  imports: [ContentSectionComponent, ProDirectoryModule],
  templateUrl: './pro-directory-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block }'],
})
export class ProDirectorySectionComponent {
  @Input() section!: ProDirectorySection
}
